<template>
	<div class="rightbox" :class="{ 'pointer-events-none': isCameraActive }">
		<div class="rightbox-upper">
			<ExplorationBox />
			<SuperClickerBox v-show="!tutorialActive" />
			<CompensationBox />
			<SurveyBox />
			<EventBox />
		</div>
		<div class="rightbox-lower">
			<SearchTurnOffButton />
			<QuickToolBox />
			<BuildingsStorageBox />
		</div>
	</div>
</template>

<script lang="ts" setup>
import BuildingsStorageBox from "@/components/BuildingsStorageBox.vue";
import CompensationBox from "@/components/CompensationBox.vue";
import EventBox from "@/components/Event/EventBox.vue";
import ExplorationBox from "@/components/ExplorationBox.vue";
import QuickToolBox from "@/components/QuickToolBox.vue";
import SearchTurnOffButton from "@/components/SearchTool/SearchTurnOffButton.vue";
import SuperClickerBox from "@/components/SuperClickerBox.vue";
import SurveyBox from "@/components/SurveyBox.vue";
import useQuestStore from "@/store/useQuestStore";
import useRuntimeStore from "@/store/useRuntimeStore";
import { storeToRefs } from "pinia";

const runtimeStore = useRuntimeStore();
const { isCameraActive } = storeToRefs(runtimeStore);

const questStore = useQuestStore();
const { tutorialActive } = storeToRefs(questStore);
</script>

<style lang="scss" scoped>
// dynamic value from HeaderComponent
$header-height: var(--header-total-height);

// dynamic value from FooterComponent
$footer-height: var(--footer-height);

.rightbox {
	position: absolute;
	top: $header-height;
	right: 0;
	@include flex-col-between;
	align-items: flex-end;
	gap: 1rem;
	padding: 0.375rem 0 0;
	height: calc(100% - $header-height - $footer-height);
	overflow: hidden;
	pointer-events: none; // disable clicks on the background to allow map interactions

	.rightbox-upper {
		@include flex-col-end;
		align-items: flex-end;
		gap: 1rem;

		:deep(.super-clicker-box) {
			margin-top: 0.5rem;
			margin-right: 0.5rem;
		}

		:deep(.compensation-box) {
			margin-top: 0.75rem;
			margin-right: 0.75rem;
		}
	}

	.rightbox-lower {
		display: flex;
		position: relative;
		right: 0;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-end;
		gap: 1.5rem;
		margin-bottom: 0.5rem;
		width: 6rem;
	}

	&:not(.pointer-events-none) {
		:deep(.rightbox-upper) {
			.exploration-box,
			.super-clicker-box,
			.compensation-box,
			.event-box,
			.survey-box {
				pointer-events: auto;
			}
		}

		:deep(.rightbox-lower) {
			.search-tool-turn-off-button-wrapper,
			.quick-tool-box,
			.buildings-storage-box-wrapper {
				pointer-events: auto;
			}
		}
	}
}
</style>
